module.exports = __webpack_public_path__ + "static/media/icsa-ball.81026e77.svg";